<template>
    <div class="filter-multi-dropdown" ref="containerRef">
        <label class="filter-multi-dropdown__label" v-if="label">
            <i v-if="icon" :class="icon"></i> {{ label }}
        </label>

        <button
            type="button"
            class="filter-multi-dropdown__trigger"
            @click="isOpen = !isOpen"
        >
            <span>{{ triggerLabel }}</span>
            <i class="fa fa-chevron-down filter-multi-dropdown__caret" :class="{ 'filter-multi-dropdown__caret--open': isOpen }"></i>
        </button>

        <div v-if="isOpen" class="filter-multi-dropdown__panel">
            <label class="filter-multi-dropdown__item">
                <input
                    type="checkbox"
                    :checked="modelValue.length === 0"
                    @change="clearAll"
                />
                <span>Todos</span>
            </label>
            <label
                v-for="option in options"
                :key="option.value"
                class="filter-multi-dropdown__item"
            >
                <input
                    type="checkbox"
                    :value="option.value"
                    :checked="modelValue.includes(option.value)"
                    @change="toggle(option.value)"
                />
                <span>{{ option.label }}</span>
            </label>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps({
    label: { type: String, required: true },
    icon: { type: String, default: null },
    options: { type: Array, required: true },
    modelValue: { type: Array, required: true }
});

const emit = defineEmits(['update:modelValue']);

const isOpen = ref(false);
const containerRef = ref(null);

const triggerLabel = computed(() => {
    if (props.modelValue.length === 0) return 'Todos';
    if (props.modelValue.length === 1) {
        const opt = props.options.find(o => o.value === props.modelValue[0]);
        return opt ? opt.label : 'Todos';
    }
    return `${props.modelValue.length} selecionados`;
});

function toggle(value) {
    const current = [...props.modelValue];
    const idx = current.indexOf(value);
    if (idx >= 0) {
        current.splice(idx, 1);
    } else {
        current.push(value);
    }
    emit('update:modelValue', current);
}

function clearAll() {
    emit('update:modelValue', []);
}

function onClickOutside(event) {
    if (containerRef.value && !containerRef.value.contains(event.target)) {
        isOpen.value = false;
    }
}

onMounted(() => document.addEventListener('click', onClickOutside));
onBeforeUnmount(() => document.removeEventListener('click', onClickOutside));
</script>
